<div [ngClass]="state=='open' ? 'main_content_open' : 'main_content'">
    <p-scrollPanel [style]="{width: '100%', height: '95vh','margin-top':'7px','padding-bottom':'70px'}" #sc>
        <div class="p-d-flex p-jc-between p-ai-center p-pt-3 p-pb-3">
            <div class="page_title">
                Client Data Management
            </div>
            <div>
                <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
            </div>
        </div>
        <div class="p-mb-5">
            <p-card>
                <div class="p-mb-3 toolbar">
                    <div class="p-grid p-ai-center">
                        <div class="p-col p-md-4 p-lg-4 p-fluid" style="padding: 0.5rem !important;">
                            <div class="p-d-flex">
                                <span class="p-input-icon-right">
                                    <i *ngIf="searchInputText !== ''" class="pi pi-times" style="cursor: pointer;"
                                        (click)="resetUserList()"></i>
                                    <input #searchInput pInputText type="text" [(ngModel)]="searchInputText"
                                        placeholder="Search Business"
                                        (keyup)="onEnterSearchUser($event,searchInput.value)" />
                                </span>
                                <div>
                                    <button pButton pRipple type="button" icon="pi pi-search"
                                        class="p-button-rounded p-button-raised p-button-sm p-ml-2"
                                        [style]="{width:'2.1rem',height:'2.1rem'}"
                                        (click)="listClients(1,searchInput.value)"></button>
                                </div>

                            </div>
                        </div>
                        <div class="p-col p-md-2 p-lg-2 p-fluid" style="padding: 0.5rem !important;">
                            <p-dropdown [options]="status" [(ngModel)]="selectedStatus" optionLabel="name"
                                optionValue="value" [showClear]="true" placeholder="Select Status"
                                (onChange)="onFilterValueChange($event)">
                            </p-dropdown>
                        </div>
                        <div class="p-col p-md-2 p-lg-2 p-fluid" style="padding: 0.5rem !important;">
                            <p-dropdown [options]="expiryStatusOptions" [(ngModel)]="selectedExpiryStatus" optionLabel="name"
                                optionValue="value" [showClear]="true" placeholder="Renewal Due"
                                (onChange)="onFilterValueChange($event)">
                            </p-dropdown>
                        </div>
                        <div class="p-col p-md-2 p-lg-2 p-fluid" style="padding: 0.5rem !important;">
                            <p-dropdown [options]="subscriptionTypeOptions" [(ngModel)]="selectedSubscriptionType" optionLabel="name"
                                optionValue="value" [showClear]="true" placeholder="Plan Type"
                                (onChange)="onFilterValueChange($event)">
                            </p-dropdown>
                        </div>
                        <div class="p-col p-md-2 p-lg-2 p-jc-end d-flex d-lg-flex d-xl-flex"
                            style="padding: 0.5rem !important;">

                        </div>
                    </div>
                </div>
                <p-table #dt1 [columns]="cols" [value]="clients"
                    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped " [autoLayout]='true'
                    [responsive]='true' [rowHover]="false">
                    <!-- [globalFilterFields]="['firstName','lastName','mobile','email','country']" -->
                    <ng-template pTemplate="header" let-columns>
                        <tr style="font-size: small;">
                            <th *ngFor="let col of columns" [ngClass]="{'sortable-header': col.sortable}"
                                (click)="onSortColumn(col)">
                                {{col.header}}
                                <i *ngIf="col.sortable" class="pi"
                                    [ngClass]="sortField == col.field ? (sortDirection == 'ASC' ? 'pi-sort-up active-sort' : 'pi-sort-down active-sort') : 'pi-sort'"></i>
                            </th>
                            <th>
                                Address Verification
                            </th>
                            <th>
                                Action
                            </th>
                            <th *ngIf="getPrivilege('businessclient_activate')">
                                Active
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-client let-columns="columns">
                        <tr style="font-size: smaller;" [ngClass]="getExpiryRowClass(client)">
                            <td *ngFor="let col of columns">
                                <span class="p-column-title">{{col.header}}</span>
                                {{client[col.field]}}
                            </td>
                            <td>
                                <span class="p-column-title">Address Verification</span>
                                <span class="status-pill"
                                    [ngClass]="getStatusConfig(client.emergencyStatus).class">
                                    {{ getStatusConfig(client.emergencyStatus).label }}
                                </span>
                            </td>
                            <td>
                                <span class="p-column-title">Action</span>
                                <a *ngIf="!client.canChangeRole; else canEdit" href="javascript:void(0);"
                                    (click)="getClient(client, 'edit_client')">
                                    <i class="pi pi-info-circle" style="font-size: 0.8rem;color:#007AFF"></i>
                                </a>
                                <ng-template #canEdit style="display:inline-block;">
                                    <div pTooltip="You cannot edit this client" tooltipPosition="left"
                                        style="display:inline-block;">
                                        <a href="javascript:void(0);" class="disabledClass">
                                            <i class="pi pi-info-circle" style="font-size: 0.8rem"></i>
                                        </a>
                                    </div>
                                </ng-template>
                                &nbsp;
                                <a *ngIf="!client.canDelete; else canDelete" href="javascript:void(0);"
                                    (click)="getClient(client, 'assign_client')">
                                    <i class="pi pi-cog" style="font-size: 0.8rem;color: #007AFF;"></i>
                                </a>
                                <ng-template #canDelete style="display:inline-block;">
                                    <div pTooltip="You cannot edit this user" tooltipPosition="left"
                                        style="display:inline-block;">
                                        <a href="javascript:void(0);" class="disabledClass">
                                            <i class="pi pi-cog" style="font-size: 0.8rem"></i>
                                        </a>
                                    </div>
                                </ng-template>
                                &nbsp;
                                <a href="javascript:void(0);" (click)="openChat(client)"
                                    pTooltip="Chat with client" tooltipPosition="left">
                                    <i class="pi pi-comment" style="font-size: 0.8rem;color: #007AFF;"></i>
                                </a>
                            </td>
                            <td *ngIf="getPrivilege('businessclient_activate')" class="last_border">
                                <span class="p-column-title">Enable/Disable</span>
                                <p-inputSwitch *ngIf="!client.canChangeRole" [(ngModel)]="client['isActive']"
                                    name="enableDisable" (onChange)="onToggle($event,client)">
                                </p-inputSwitch>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="columns.length+2">
                                <div *ngIf="isLoading" class="alignCenter">
                                    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                                    </p-progressSpinner>
                                </div>
                                <p-messages *ngIf="clients?.length == 0 && !isLoading" key="errMsg" class="alignCenter">
                                    <ng-template pTemplate>
                                        <i class="pi pi-copy" style="font-size: 2rem"></i>
                                        <div class="p-ml-2">NO DATA FOUND</div>
                                    </ng-template>
                                </p-messages>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <p-paginator #p [rows]="pageSize" [totalRecords]="totalCount" (onPageChange)="paginate($event)">
                </p-paginator>
            </p-card>
        </div>
    </p-scrollPanel>
</div>

<!-- ADD/EDIT CLIENT MODAL -->
<p-dialog #clientDialog [header]="headerName" [(visible)]="displayAddEditModal" [modal]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="true" [maximizable]="true" (onHide)="clearFormData()"
    (onShow)="showDialogMaximized($event,clientDialog)">
    <p-tabView [style]="{'min-width': '60vw'}">
    <p-tabPanel header="Business Info">
    <p-messages key="errMsg" [style]="{'font-size': '12px'}"></p-messages>
    <form role="form" #clientForm="ngForm">
        <div class="p-grid p-ai-center">
            <div class="p-col p-md-4 p-lg-4">
                <div class="row">
                    <div class="form-group col-sm-10 text-center">
                        <label class="text-center">Business Logo</label>
                        <div class="fileinput fileinput-new text-center">
                            <div class="user-image mt-2">
                                <div class="fileinput-new img-thumbnail">
                                    <img style="width: 100px;height: 100px;object-fit: cover;"
                                        [src]="businessProfileUrl" alt="" (error)="fileFailedToLoad($event)" />
                                </div>
                                <div class="user-image-buttons">
                                    <span class="btn btn-azure btn-file btn-sm" (click)="displayCropModal = true">
                                        <span class="fileinput-new">
                                            <i class="fa fa-pencil"></i>
                                        </span>
                                    </span>
                                    <a *ngIf="!imageInputError" href="javascript:void(0)"
                                        (click)="confirmDeleteImageDialog()"
                                        class="btn fileinput-exists btn-red btn-sm">
                                        <i class="fa fa-times"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-col p-md-8 p-lg-8 p-fluid">
                <div class="row form-group">
                    <label class="col-sm-4 control-label">Business Url<span class="symbol required"></span></label>
                    <div class="col-sm-8">
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon">https://chatstasy.com/</span>
                            <input pInputText type="text" name="shortName" [(ngModel)]="shortName"
                                placeholder="Enter business url" (keypress)="keyPressAlphaNumericWithCharacters($event)"
                                required />
                        </div>
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Business Name<span class="symbol required"></span></label>
                    <div class="col-sm-8">
                        <input type="text" name="businessName" class="form-control" placeholder="Enter Business Name"
                            [(ngModel)]="businessName" [disabled]="disabled" required />
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Address 1</label>
                    <div class="col-sm-8">
                        <textarea pInputTextarea type="text" name="address" class="form-control address-readonly"
                            [(ngModel)]="address" [disabled]="true"></textarea>
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Address 2</label>
                    <div class="col-sm-8">
                        <textarea pInputTextarea type="text" name="address2" class="form-control address-readonly"
                            [(ngModel)]="address2" [disabled]="true"></textarea>
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">City</label>
                    <div class="col-sm-8">
                        <input type="text" name="city" class="form-control address-readonly"
                            [(ngModel)]="city" [disabled]="true" />
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">State</label>
                    <div class="col-sm-8">
                        <input type="text" name="business_state" class="form-control address-readonly"
                            [(ngModel)]="business_state" [disabled]="true" />
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Zip Code</label>
                    <div class="col-sm-8">
                        <input type="text" name="zipcode" class="form-control address-readonly"
                            [(ngModel)]="zipcode" [disabled]="true" />
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Country</label>
                    <div class="col-sm-8">
                        <select [(ngModel)]="country" name="country"
                            class="form-control select_disabled address-readonly"
                            style="height: 34px;" [disabled]="true">
                            <option [value]="null" selected disabled>Select Country</option>
                            <option *ngFor="let country of countries" [ngValue]="country.isoCode">
                                {{ country.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Phone<span class="symbol required"></span></label>
                    <div class="col-sm-8">
                        <span class="input-icon"><input type="text" class="form-control" placeholder="Enter Mobile"
                                name="phone" [(ngModel)]="phone" [disabled]="disabled" maxlength="10"
                                (keypress)="validateDigitOnly($event)">
                            <span class="number">+1</span></span>
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Fax</label>
                    <div class="col-sm-8">
                        <input type="text" name="fax" class="form-control" placeholder="Enter Fax" [(ngModel)]="fax"
                            [disabled]="disabled" />
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">EIN<span class="symbol required"></span></label>
                    <div class="col-sm-8">
                        <div class="ein-field-row">
                            <input type="text" name="ein" class="form-control ein-input" placeholder="Enter EIN"
                                [(ngModel)]="ein" [disabled]="disabled" />
                            <span class="ein-status-pill" [ngClass]="getEinStatusConfig(einVerificationStatus).class">
                                <i [ngClass]="getEinStatusConfig(einVerificationStatus).icon"></i>{{
                                getEinStatusConfig(einVerificationStatus).label }}
                            </span>
                            <p-button [icon]="einValidateLoading ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'" label="Retry" styleClass="p-button-sm p-button-outlined"
                                [disabled]="disabled || einValidateLoading || !canRetryEinValidation()"
                                (click)="retryEinValidation()"></p-button>
                        </div>
                        <span class="ein-status-caption">{{ getEinStatusCaption(einVerificationStatus) }}</span>
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;" *ngIf="einHistory.length > 0 || einHistoryLoading">
                    <label class="col-sm-4 control-label">EIN Verification History</label>
                    <div class="col-sm-8">
                        <div class="ein-history-list">
                            <div class="ein-history-row" *ngFor="let entry of einHistory">
                                <span class="ein-status-pill" [ngClass]="getEinStatusConfig(entry.resolvedStatus).class">
                                    <i [ngClass]="getEinStatusConfig(entry.resolvedStatus).icon"></i>{{ getEinStatusConfig(entry.resolvedStatus).label }}
                                </span>
                                <span class="ein-history-trigger">
                                    <i [ngClass]="getEinTriggerConfig(entry.triggeredBy).icon"></i>{{ getEinTriggerConfig(entry.triggeredBy).label }}<ng-container *ngIf="entry.triggeredByLabel"> — {{ entry.triggeredByLabel }}</ng-container>
                                </span>
                                <span class="ein-history-date">{{ entry.createdAt | date:'short' }}</span>
                                <span class="ein-history-message" *ngIf="entry.message">{{ entry.message }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Website</label>
                    <div class="col-sm-8">
                        <input type="text" name="website" class="form-control" placeholder="Enter Website Url"
                            [(ngModel)]="websiteUrl" [disabled]="disabled" />
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Timezone</label>
                    <div class="col-sm-8">
                        <select [(ngModel)]="timezone" name="timezone" class="form-control"
                            placeholder="Select a timezone" style="height: 34px;" required>
                            <option [value]="null" disabled>Select a timezone</option>
                            <option *ngFor="let data of timezoneList" [ngValue]="data">
                                {{ data }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row form-group" style="margin-bottom: 10px;">
                    <label class="col-sm-4 control-label">Business Type<span class="symbol required"></span></label>
                    <div class="col-sm-8">
                        <select [(ngModel)]="selectedBusinessType" name="businessType" class="form-control"
                            style="height: 34px;" [ngClass]="disabled? 'select_disabled':''" [disabled]="disabled">
                            <option [value]="null" disabled>Select business type</option>
                            <option *ngFor="let business of businessType" [value]="business.id">
                                {{ business.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="p-d-flex p-jc-end p-mt-3">
        <p-button *ngIf="headerName == 'Edit Business'" icon="pi pi-save" label="Save" (click)="editClient(clientForm)"
            [disabled]="disabled">
        </p-button>
    </div>
    </p-tabPanel>

    <p-tabPanel header="Root User Details" [disabled]="headerName != 'Edit Business'">
        <div *ngIf="rootUserLoading" class="alignCenter">
            <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
        </div>
        <div *ngIf="!rootUserLoading && !rootUser" class="p-mb-3">
            No root user found for this business.
        </div>
        <div *ngIf="!rootUserLoading && rootUser">
            <div class="row form-group" style="margin-bottom: 10px;">
                <label class="col-sm-4 control-label">First Name</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" [value]="rootUser.firstName" disabled />
                </div>
            </div>
            <div class="row form-group" style="margin-bottom: 10px;">
                <label class="col-sm-4 control-label">Last Name</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" [value]="rootUser.lastName" disabled />
                </div>
            </div>
            <div class="row form-group" style="margin-bottom: 10px;">
                <label class="col-sm-4 control-label">Email</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" [value]="rootUser.email" disabled />
                </div>
            </div>
            <div class="row form-group" style="margin-bottom: 10px;">
                <label class="col-sm-4 control-label">Mobile</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" [value]="rootUser.mobile" disabled />
                </div>
            </div>
            <div class="row form-group" style="margin-bottom: 10px;">
                <label class="col-sm-4 control-label">Role</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" [value]="getRootUserRoles()" disabled />
                </div>
            </div>
        </div>
    </p-tabPanel>

    <p-tabPanel header="Reset Password" [disabled]="headerName != 'Edit Business'">
        <p-messages key="errMsg" [style]="{'font-size': '12px'}"></p-messages>
        <form role="form" #resetPasswordForm="ngForm">
            <div class="row form-group" style="margin-bottom: 10px;">
                <label class="col-sm-4 control-label">New Password<span class="symbol required"></span></label>
                <div class="col-sm-8">
                    <input class="form-control" type="password" name="newPassword"
                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%!]).{8,40}$" placeholder="Enter Password"
                        [(ngModel)]="newPassword" #newPasswordModel="ngModel" />
                    <small *ngIf="newPasswordModel.invalid && newPasswordModel.touched" class="p-error">
                        Password should be 8-40 characters and contain atleast one uppercase letter, one lowercase
                        letter, one number and one special character (@#$%!).
                    </small>
                </div>
            </div>
            <div class="row form-group" style="margin-bottom: 10px;">
                <label class="col-sm-4 control-label">Confirm Password<span class="symbol required"></span></label>
                <div class="col-sm-8">
                    <input class="form-control" type="password" name="confirmPassword"
                        pattern="{{ newPasswordModel.value }}" placeholder="Re-enter Password"
                        [(ngModel)]="confirmPassword" #confirmPasswordModel="ngModel" required />
                    <small *ngIf="confirmPasswordModel.errors?.pattern" class="p-error">
                        Passwords do not match.
                    </small>
                </div>
            </div>
        </form>
        <div class="p-d-flex p-jc-end p-mt-3">
            <p-button icon="pi pi-cog" label="Reset Password" (click)="resetPassword(resetPasswordForm)"
                [disabled]="disabled || !rootUser || !resetPasswordForm.valid">
            </p-button>
        </div>
    </p-tabPanel>
    </p-tabView>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="displayAddEditModal = false" label="Cancel"
            styleClass="p-button-danger p-button-text"></p-button>
    </ng-template>
    <div *ngIf="isLoading" class="progressLayout">
        <div class="progressContainer">
            <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
        </div>
    </div>
</p-dialog>
<!-- ASSIGN TWILLIO NUMBER -->
<p-dialog #clientDialog [header]="headerName" [(visible)]="displayChangeModal" [modal]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="true" (onHide)="clearFormData()"
    (onShow)="showDialogMaximized($event,clientDialog)">
    <p-messages key="errMsg" [style]="{'font-size': '12px'}"></p-messages>
    <form style="min-width: 40vw;padding: 1rem;" role="form" #clientForm="ngForm">
        <div class="row form-group" style="margin-bottom: 10px;">
            <label class="col-sm-5 control-label">Assign Twillio Number<span class="symbol required"></span></label>
            <div class="col-sm-7">
                <span class="input-icon"><input type="text" class="form-control" placeholder="Enter Twilio Number"
                        name="twilioNumber" [(ngModel)]="twilioNumber" [disabled]="disabled" maxlength="10"
                        (keypress)="validateDigitOnly($event)">
                    <span class="number">+1</span></span>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="displayChangeModal = false" label="Cancel"
            styleClass="p-button-danger p-button-text"></p-button>
        <p-button icon="pi pi-save" label="Save" (click)="updateSmsNumber(clientForm)" [disabled]="disabled">
        </p-button>
    </ng-template>
    <div *ngIf="isLoading" class="progressLayout">
        <div class="progressContainer">
            <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
        </div>
    </div>
</p-dialog>
<!-- REMOVE USER MODAL -->
<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" [style]="{width:'45vw'}">
</p-confirmDialog>

<!-- TOAST -->
<p-toast position="bottom-right" key="br" [baseZIndex]="10001"></p-toast>